module.exports = __webpack_public_path__ + "img/3-11-21-1-1-1-711x800.2103b182.jpg";